<template>
	<div id="app" class="app">
		<router-view />
	</div>
</template>
<script>
export default {
	mounted() {},
}
</script>
<style>
.app {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	min-width: 1338px;
	/* min-height: 100%; */
}
</style>
